import { StaticPricingTab } from './pricing-display-static.types';

export const PROFESSIONAL_SERVICES_TAB: StaticPricingTab = {
  id: 'professional-services',
  label: 'Professional Services',
  tabNotes: [
    { type: 'heading', text: 'Description of Professional Services Packages' },
  ],
  sections: [
    {
      title: 'STANDARD — $995',
      headers: [],
      rows: [],
      notes: [
        {
          type: 'paragraph',
          text: "The Standard Package is for customers who may have limited needs or budgetary and/or time constraints. The goal of this package is to ensure that a new or existing customer receives the advanced support required to be successful with using and integrating AccuZIP's enhanced features and APIs into their current workflow. This package includes 5-hrs of custom programming typically used for Commands, Scripts, Advanced Merge/Purge Data Manipulation Requests and basic API and Third Party integrations. The Standard package covers set-up and configuration, familiarization with created tools as well as live online training geared toward getting started with and using the created tools.",
        },
        {
          type: 'paragraph',
          text: '$995.00 (5-Hours @ $225/hr - Reg. $1,125.00 ) 12% Discount',
        },
        {
          type: 'paragraph',
          text: 'Total work effort pursuant to this SOW shall be 5 Professional Services Hours. Additional PSG project and support hours billed at $225/hr.',
        },
      ],
    },
    {
      title: 'PERFORMANCE — $1,995',
      headers: [],
      rows: [],
      notes: [
        {
          type: 'paragraph',
          text: 'The Performance Package is for customers who have more complex and custom configurations. This package will yield tangible results in a short period of time. The Performance Package is ideal for customers with multiple users and/or those who plan to take advantage of multiple AccuZIP integrations, APIs, UI development needs and using other add-on modules. It includes all of the available services of the Standard package plus advanced integrations into Third Party applications using AccuZIP APIs, Open Source and custom reports and data grooming techniques.',
        },
        {
          type: 'paragraph',
          text: '$1,995.00 (10-Hours @ $225/hr - Reg. $2,250.00) 12% Discount',
        },
        {
          type: 'paragraph',
          text: 'Total work effort pursuant to this SOW shall be 10 Professional Services Hours. Additional PSG project and support hours billed at $225/hr.',
        },
      ],
    },
    {
      title: 'PRO — $3,995',
      headers: [],
      rows: [],
      notes: [
        {
          type: 'paragraph',
          text: 'The Pro Package is an extension of the Performance Package and is designed for customers with more users, more seats and/or who expect to fully exploit the complete AccuZIP Enterprise solutions feature set including advanced API and Third Party integrations. With the Pro Package comes additional online training and additional time allocated for custom programming, Third Party API integration and UI development. The Pro Package also includes full-service consulting and mail management services including access to postal and mail optimization experts.',
        },
        {
          type: 'paragraph',
          text: '$3995.00 (20-Hours @ $225/Hr = Reg $4,500) 12% Discount',
        },
        {
          type: 'paragraph',
          text: 'Total work effort pursuant to this SOW shall be 20 Professional Services Hours. Additional PSG project and support hours billed at $225/hr.',
        },
      ],
    },
    {
      title: 'Professional Services Group Product Codes',
      headers: ['Code', 'Price'],
      rows: [
        ['PSGSTD', '$995'],
        ['PSGPER', '$1995'],
        ['PSGPRO', '$3995'],
        ['PSGHRLY', '$225/Hr.'],
      ],
    },
    {
      title:
        'Franchise Development Department Professional Services (performed by Donna Sue Tackett, Franchise Development Manner)',
      headers: ['Postal Process/Data Hygiene', 'Price'],
      rows: [
        ['1-10,000 records (total based received)', '$99.00 per File'],
        ['10,000-50,000 records (total based on file received)', '$149.00'],
        ['50,001-100,000 records (total based on file received)', '$225.00'],
        ['100,001-250,000 records (total based on file received)', '$300.00'],
      ],
    },
    {
      title: 'AccuEngage',
      headers: ['Product', 'Price'],
      rows: [['AccuZIP – AccuEngage Informed Delivery Setup', '$495.00']],
      notes: [
        { type: 'list-item', text: 'Includes: 1 Campaign Setup' },
        { type: 'list-item', text: 'Pre-Campaign Analysis Report' },
        { type: 'list-item', text: 'Post-Campaign Analysis Report' },
        {
          type: 'list-item',
          text: 'Representative Image and Target URL Upload',
        },
        { type: 'list-item', text: 'Ride-Along Image and Target URL Upload' },
        {
          type: 'paragraph',
          text: 'Includes 1 Managed Campaign. Additional campaigns $99/each',
        },
      ],
    },
  ],
};
